import { render, staticRenderFns } from "./WorkPermitSelect.vue?vue&type=template&id=b03a665a"
import script from "./WorkPermitSelect.vue?vue&type=script&lang=js"
export * from "./WorkPermitSelect.vue?vue&type=script&lang=js"
import style0 from "./WorkPermitSelect.vue?vue&type=style&index=0&id=b03a665a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports